import type { ProductWrapper, ProductWrapperType } from '@/api/generated/model';

export const WRAPPER_TYPE_LABELS: Record<ProductWrapperType, string> = {
  isa: 'ISA',
  lisa: 'LISA',
  sipp: 'SIPP',
  gia: 'GIA',
  juniorIsa: 'JISA',
  pension: 'Pension',
};

export const WRAPPER_TYPES = Object.keys(WRAPPER_TYPE_LABELS) as ProductWrapperType[];

const UK_ALLOWANCE_LIMITS: Record<ProductWrapperType, number> = {
  isa: 20_000,
  lisa: 4_000,
  sipp: 60_000,
  gia: 0,
  juniorIsa: 9_000,
  pension: 60_000,
};

/** UK tax year start (April–March): before April use previous calendar year. */
export function currentUkTaxYear(): number {
  const now = new Date();
  return now.getMonth() < 3 ? now.getFullYear() - 1 : now.getFullYear();
}

export function defaultProductWrapper(wrapperType: ProductWrapperType): ProductWrapper {
  return {
    wrapperType,
    jurisdictionCode: 'GB',
    taxYear: currentUkTaxYear(),
    allowanceUsed: 0,
    allowanceLimit: UK_ALLOWANCE_LIMITS[wrapperType],
  };
}
